import React from 'react'

const InputField = ({placeholder, label}) => {
    return (
        <div className='flex flex-col gap-[6px]'>
            <span className='text-[#344054] text-[14px] font-semibold text-start'>{label}</span>
            <input type="text" className='outline-none border-[1px] font-medium border-[#D0D5DD] rounded-[8px] px-[14px] py-[10px] placeholder:text-[#667085] text-[#101828]' placeholder={placeholder} />
        </div>
    )
}

export default InputField;